import HolderOutlined from '@ant-design/icons/lib/icons/HolderOutlined'
import { Button } from 'antd'
import { FC, useContext } from 'react'
import { RowContext } from '../../custom-row'

interface DragHandlerProps {}

const DragHandler: FC<DragHandlerProps> = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext)

    return (
        <Button
            type='text'
            size='small'
            icon={<HolderOutlined />}
            style={{ cursor: 'move' }}
            ref={setActivatorNodeRef}
            {...listeners}
        />
    )
}

export default DragHandler
